import { recordOf, safeManifestUrl } from "./manifest-record";
export function firstVariantFacts(manifest: unknown): {
  maxTicks: number | null;
  maxTurns: number | null;
  numAgents: number | null;
} {
  const variants = recordOf(manifest).variants;
  const first = Array.isArray(variants) ? recordOf(variants[0]) : {};
  const gameConfig = recordOf(first.game_config);
  return {
    maxTicks:
      typeof gameConfig.maxTicks === "number" ? gameConfig.maxTicks : null,
    maxTurns:
      typeof gameConfig.max_turns === "number" ? gameConfig.max_turns : null,
    numAgents:
      typeof gameConfig.num_agents === "number" ? gameConfig.num_agents : null,
  };
}
export function manifestRulesDocPage(manifest: unknown): {
  title: string;
  href: string;
} | null {
  const pages = recordOf(recordOf(recordOf(manifest).game).docs).pages;
  const page = Array.isArray(pages)
    ? pages
        .map((p) => recordOf(p))
        .find((p) => typeof p.title === "string" && /rules/i.test(p.title))
    : undefined;

  if (!page) return null;

  const content = recordOf(page.content);
  const href = content.type === "uri" ? safeManifestUrl(content.value) : null;
  return href && typeof page.title === "string"
    ? { title: page.title, href }
    : null;
}
